import { memoizeOne } from "~/EasyProjectsCommon/memoizeOne";

export const createFunctionsCombiner = () => {
    return memoizeOne(<T extends (...args: any[]) => any>(...funcs: T[]) => {
        const result = (...args: any[]) => {
            funcs.forEach(f => f && f(...args));
        };

        return result as T;
    });
};

// prettier-ignore
interface Pipe {
    <Args extends any[], A2, R>(
        f1: (...args: Args) => A2,
        f2: F1<A2, R>
    ): (...args: Args) => R;

    <Args extends any[], A2, A3, R>(
        f1: (...args: Args) => A2,
        f2: F1<A2, A3>,
        f3: F1<A3, R>
    ): (...args: Args) => R;

    <Args extends any[], A2, A3, A4, R>(
        f1: (...args: Args) => A2,
        f2: F1<A2, A3>,
        f3: F1<A3, A4>,
        f4: F1<A4, R>
    ): (...args: Args) => R;

    <Args extends any[], A2, A3, A4, A5, R>(
        f1: (...args: Args) => A2,
        f2: F1<A2, A3>,
        f3: F1<A3, A4>,
        f4: F1<A4, A5>,
        f5: F1<A5, R>
    ): (...args: Args) => R;

    <Args extends any[], A2, A3, A4, A5, A6, R>(
        f1: (...args: Args) => A2,
        f2: F1<A2, A3>,
        f3: F1<A3, A4>,
        f4: F1<A4, A5>,
        f5: F1<A5, A6>,
        f6: F1<A6, R>
    ): (...args: Args) => R;

    <Args extends any[], A2, A3, A4, A5, A6, A7, R>(
        f1: (...args: Args) => A2,
        f2: F1<A2, A3>,
        f3: F1<A3, A4>,
        f4: F1<A4, A5>,
        f5: F1<A5, A6>,
        f6: F1<A6, A7>,
        f7: F1<A7, R>
    ): (...args: Args) => R;
}

export const pipe: Pipe = (...funcs: Function[]) => {
    const result = funcs.reduce(
        (prev, next) =>
            (...args: any[]) =>
                next(prev(...args))
    );
    return result as any;
};
